var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.136 3.70174L18.1933 14.2143C18.3266 14.5281 18.3849 14.7833 18.4016 15.0484C18.4349 15.6677 18.2183 16.2696 17.7934 16.7329C17.3684 17.1945 16.7935 17.467 16.1686 17.5H3.9707C3.71241 17.4843 3.45412 17.4257 3.2125 17.3349C2.00437 16.8477 1.42113 15.4769 1.91271 14.2887L8.01169 3.69431C8.21999 3.3219 8.5366 3.00068 8.9282 2.79424C10.0613 2.16585 11.5028 2.57872 12.136 3.70174ZM10.7946 10.6298C10.7946 11.0261 10.4696 11.3573 10.0697 11.3573C9.66974 11.3573 9.33646 11.0261 9.33646 10.6298V8.29373C9.33646 7.89654 9.66974 7.57533 10.0697 7.57533C10.4696 7.57533 10.7946 7.89654 10.7946 8.29373V10.6298ZM10.0697 14.1813C9.66974 14.1813 9.33646 13.8502 9.33646 13.4547C9.33646 13.0575 9.66974 12.7272 10.0697 12.7272C10.4696 12.7272 10.7946 13.05 10.7946 13.4456C10.7946 13.8502 10.4696 14.1813 10.0697 14.1813Z",
    fill: "#EF4343"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.87d5b50810f73f99a99f462f374ffb76.svg";
export { ForwardRef as ReactComponent };